export default __webpack_public_path__ + "static/media/logo-lsbd-small.10f489a1.svg";